export const VULNERABILITY_JIRA_TICKETS_LABELS = {
  SECTION_LABEL: 'Jira tickets',
  NO_TICKETS: 'No tickets yet',
  CREATE_TICKET: 'Create ticket',
  TICKET_ID: 'Ticket ID',
  STATUS: 'Status',
  ASSIGNEE: 'Assignee',
  UPDATED: 'Updated',
  OPEN_TICKET: 'Open ticket in Jira',
  DISCONNECTED_ALERT_TITLE: 'Jira is disconnected',
  DISCONNECTED_ALERT_BODY: 'Reconnect to see live status and create new tickets.'
};

// Poll Jira ticket updates once per minute.
export const VULNERABILITY_JIRA_TICKETS_POLL_INTERVAL_MS = 60_000;

export function getTicketCountLabel(count) {
  if (count === 1) {
    return '1 Ticket';
  }

  return `${count} Tickets`;
}
